import { createRouter, createWebHistory } from 'vue-router';
import MarkdownViewer from './components/MarkdownViewer.vue';

const routes = [
  { path: '/', name: 'Home', component: MarkdownViewer },
  { path: '/linux-commands/:command', name: 'Command', component: MarkdownViewer }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
